import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import api from "@/api";
import PaperList from "@/components/mockExam/PaperList.vue";
import { ElMessage } from "element-plus";
export default {
  components: {
    PaperList
  },
  data() {
    return {
      examDialogFormVisible: false,
      paperDialogTableVisible: false,
      examList: [],
      form: {
        examType: 'Mock',
        assessmentLevel: '模拟'
      },
      emptyForm: {
        examType: 'Mock',
        assessmentLevel: '模拟'
      },
      paperList: [],
      groupList: [],
      examPlanId: 0
    };
  },
  beforeMount() {
    this.getMockExamPlanList();
    this.getUserGroupList();
  },
  methods: {
    refreshTable() {
      this.$nextTick(() => {
        // 在数据加载完，重新渲染表格 如果不刷新会出现数据缓存
        this.$refs['table'].doLayout();
      });
    },
    async getMockExamPlanList() {
      const list = await api.getMockExamPlanList();
      this.examList = list.map(item => {
        return {
          ...item,
          initialPaperExist: item.initialPaper ? '已配置' : '未配置',
          retakePaperExist: item.retakePaper ? '已配置' : '未配置',
          userGroupIds: item.userGroupIds ? item.userGroupIds.split(',').map(Number) : []
        };
      });
    },
    async getUserGroupList() {
      const list = await api.getUserGroupList();
      this.groupList = list;
    },
    async copyExamPlan(row) {
      const params = {
        sourcePlanId: row.id,
        newPlanName: row.planName + "-副本"
      };
      await api.copyExamPlan(params).then(() => {
        ElMessage.success('复制成功');
      });
      this.getMockExamPlanList();
      this.refreshTable();
    },
    createExam() {
      this.form = {
        ...this.emptyForm
      };
      this.examDialogFormVisible = true;
    },
    handelEdit(row) {
      this.form = row;
      this.examDialogFormVisible = true;
    },
    async editSave() {
      if (this.form.id) {
        await api.updateMockExamPlan({
          ...this.form,
          participantType: "SOMEONE",
          userGroupIds: this.form.userGroupIds.join(',')
        }).then(() => {
          ElMessage.success('更新成功');
        });
      } else {
        await api.createMockExamPlan({
          ...this.form,
          participantType: "SOMEONE",
          userGroupIds: this.form.userGroupIds.join(',')
        }).then(() => {
          ElMessage.success('创建成功');
        });
      }
      this.examDialogFormVisible = false;
      this.getMockExamPlanList();
      this.refreshTable();
    },
    async handelDelete(row) {
      await api.deleteMockExamPlan({
        id: row.id
      });
      this.getMockExamPlanList();
      this.refreshTable();
    },
    async handelAddPaper(row) {
      this.examPlanId = row.id;
      this.paperDialogTableVisible = true;
    }
  }
};